import { getPreferredProduct } from '__core/shared/util/salestrekker';
import template from './honeyButton.template.html';
import templateRefer from './honey.template.html';

export default {
  template,
  bindings: {
    contacts: '<',
    loan: '<',
    ticket: '<',
    isDisabled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $timeout, $mdDialog, honeyService, OwnershipType, TransactionType) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.destroyWatch = null;

      ctrl.initialize = () => {
        ctrl.ticketClientTypes = ctrl.ticketClientTypes || [];
        ctrl.contacts = _.filter(ctrl.contacts || [], (c) => !c?.isCompany);
        ctrl.loan = ctrl.loan || {};
        ctrl.ticket = ctrl.ticket || {};
        ctrl.isDisabled = ctrl.isDisabled || false;
      };

      ctrl.openDialog = ($event) => {
        $event.stopPropagation();
        $mdDialog.show({
          targetEvent: $event,
          locals: {
            contacts: ctrl.contacts || [],
            loan: ctrl.loan || {},
            ticket: ctrl.ticket || {},
            isDisabled: ctrl.isDisabled || false
          },
          template: templateRefer,
          controllerAs: '$ctrl',
          multiple: true,
          controller(contacts, loan, ticket, isDisabled) {
            const self = this;
            self.currentTimeZone = $rootScope.CurrentTimeZone();
            self.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
            self.organization = $rootScope.CurrentOrganization;
            self.contacts = contacts;
            self.loan = loan;
            self.securities = self.loan?.securityDetails?.securitySplits || [];
            self.fundsRequired = self.loan?.fundingWorksheets?.fundsRequired || [];
            self.ticket = ticket;
            self.isDisabled = isDisabled;
            self.filteredContacts = [];
            self.security = {};
            self.fundRequired = {};
            self.honeyModel = {
              idSecurity: '',
              idInsuredContact: '',
              idAdditionalInsuredContacts: [],
              referralReason: '',
              isAutomation: false,
              clientRequestedReferral: false,
              clientNotifiedOfFee: false,
              referralGuidelinesFollowed: false
            };
            self.errorMessages = [];
            self.hasError = false;
            self.isSubmitted = false;
            self.isSending = false;
            self.isLoading = false;

            self.preferredProduct = getPreferredProduct(self.loan?.reviewProducts);

            self.getSecurity = () =>
              _.find(self.securities || [], (s) => s?.id === self.honeyModel.idSecurity);

            self.getFundRequired = () =>
              _.find(
                self.fundsRequired || [],
                (f) => f?.idSecurity === self.honeyModel.idSecurity
              );

            self.hasOwnership = (idContact) => {
              const ownership = _.find(
                self.security?.ownership || [],
                (o) => o?.idContact === idContact
              );
              if (ownership) {
                return ownership?.percent > 0;
              }
              return false;
            };

            self.setFilteredContacts = () =>
              _.filter(self.contacts || [], (c) => self.hasOwnership(c?.id));

            self.toggleSecurity = () => {
              self.security = self.getSecurity();
              self.fundRequired = self.getFundRequired();
              self.filteredContacts = self.setFilteredContacts();
              if (self.filteredContacts?.length === 1) {
                self.honeyModel.idInsuredContact = self.filteredContacts[0]?.id || '';
              } else {
                self.honeyModel.idInsuredContact = '';
              }
              self.honeyModel.idAdditionalInsuredContacts = [];
              self.honeyModel.clientRequestedReferral = false;
              self.honeyModel.clientNotifiedOfFee = false;
              self.honeyModel.referralGuidelinesFollowed = false;
            };

            if (self.securities?.length === 1) {
              self.honeyModel.idSecurity = self.securities[0]?.id;
              self.toggleSecurity();
            }

            self.getInsuranceType = () => {
              if (self.security) {
                switch (self.security?.ownershipType?.name) {
                  case OwnershipType?.owner_occupied?.name:
                    return 'Home & contents';
                  case OwnershipType?.investment?.name:
                    return 'Landlord';
                  default:
                    return '-';
                }
              }
              return '-';
            };

            self.isPurchased = () => {
              if (self.fundRequired) {
                switch (self.fundRequired?.transactionType?.name) {
                  case TransactionType?.purchase?.name:
                    return 'Yes';
                  case TransactionType?.refinance?.name:
                  case TransactionType?.top_up_or_increase?.name:
                  case TransactionType?.equity_release?.name:
                    return 'No';
                  default:
                    return '-';
                }
              }
              return '-';
            };

            self.canSelect = ({ idContact, type }) => {
              if (type === 'insured') {
                return _.indexOf(self.honeyModel.idAdditionalInsuredContacts, idContact) > -1;
              }
              return idContact === self.honeyModel.idInsuredContact;
            };

            self.areAllRequiredFieldsFilledIn = () => {
              if (
                !self.honeyModel?.idSecurity ||
                !self.honeyModel?.idInsuredContact ||
                !self.honeyModel?.referralReason ||
                !self.honeyModel?.clientRequestedReferral ||
                !self.honeyModel?.clientNotifiedOfFee ||
                !self.honeyModel?.referralGuidelinesFollowed ||
                !self.preferredProduct
              ) {
                return false;
              }
              return !self.isDisabled;
            };

            self.canSend = () => {
              if (!self.areAllRequiredFieldsFilledIn() || !self.preferredProduct) {
                return false;
              }

              return !self.isDisabled;
            };

            self.getContactName = ({ idContact }) => {
              const contact = _.find(self.contacts || [], (c) => c?.id === idContact);
              return contact?.getName() || 'N/A';
            };

            self.confirm = () => {
              if (self.canSend()) {
                self.errorMessages = [];
                self.hasError = false;
                self.isLoading = true;
                self.isSending = false;
                self.isSubmitted = false;
                honeyService
                  .refer({
                    idTicket: self.ticket?.id,
                    honeyDetails: self.honeyModel
                  })
                  .then((result) => {
                    self.isSending = true;
                    self.isLoading = false;
                    if (result?.status) {
                      self.isSubmitted = true;
                      $timeout(() => {
                        $mdDialog.hide();
                      }, 5000);
                    } else {
                      self.hasError = true;
                      if (result?.errors?.length) {
                        const len = result?.errors?.length || 0;
                        for (let e = 0; e < len; e += 1) {
                          const error = result?.errors[e];
                          const message = error?.label
                            ? `${error?.label?.sanitize()} -> ${error?.message || ''}`
                            : error?.message || error || '';
                          self.errorMessages.push(message);
                        }
                      } else {
                        self.errorMessages.push(result?.errorMessage);
                      }
                      self.errorMessages.unshift('Honey errors:');
                    }
                  });
              }
            };

            self.cancel = () => {
              $mdDialog.cancel();
            };
          }
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        if (ctrl.destroyWatch) {
          ctrl.destroyWatch();
        }
      };
    }
  }
};
